import React from "react";
import { NAV_LINKS, BRAND } from "../data/content";
import { Logo } from "./Logo";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#4A342A] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <Logo light heightClass="h-14 sm:h-16" />
            <p className="mt-6 max-w-sm text-base font-light text-white/60 leading-relaxed">
              Co-living premium con administración profesional. Habitaciones amuebladas,
              amenidades y servicios incluidos.
            </p>
          </div>

          {/* Nav */}
          <div className="md:col-span-4">
            <h4 className="text-xs font-bold tracking-[0.15em] uppercase text-white/40">Navegación</h4>
            <div className="mt-6 grid grid-cols-2 gap-y-3">
              {NAV_LINKS.map((link) => (
                <button
                  key={link.id}
                  data-testid={`footer-link-${link.id}`}
                  onClick={() => scrollTo(link.id)}
                  className="text-left text-base font-light text-white/70 hover:text-white transition-colors"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="text-xs font-bold tracking-[0.15em] uppercase text-white/40">Contacto</h4>
            <div className="mt-6 space-y-3">
              <a
                data-testid="footer-whatsapp"
                href={`https://wa.me/${BRAND.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block text-base font-light text-white/70 hover:text-white transition-colors"
              >
                {BRAND.whatsappDisplay}
              </a>
              <a
                data-testid="footer-email"
                href={`mailto:${BRAND.email}`}
                className="block text-base font-light text-white/70 hover:text-white transition-colors"
              >
                {BRAND.email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-xs font-light text-white/50">
            © {new Date().getFullYear()} {BRAND.managedBy}. Todos los derechos reservados.
          </p>
          <p className="text-xs font-light text-white/50">COLLECTIVE CO LIVING · CDMX, México</p>
        </div>
      </div>
    </footer>
  );
};
